module.exports = __webpack_public_path__ + "static/media/audio-engineer.554075a6.svg";